import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const More = () => {
  const server_folder = localStorage.getItem("server_folder");
  const grage_referal_code = localStorage.getItem("grage_referal_code");
  const grage_id = localStorage.getItem("grage_id");
  const grage_name = localStorage.getItem("grage_name");
  const garageLoginNumber = localStorage.getItem("garageLoginNumber");
  const membership_status = localStorage.getItem("membership_status");
  const membership_hide_show = localStorage.getItem("membership_hide_show");

  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const navigate = useNavigate();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  // Generate referral URL with garage name
  const referralUrl = `${
    window.location.origin + server_folder
  }/register?ref=${grage_referal_code}`;

  // WhatsApp message
  const whatsappMessage = `🚗 Join MydigiGarage Family! 
Hey! I'm using MydigiGarage for my Shubha Garage and it's amazing! 

✨ Benefits: 
✓ Easy vehicle management 
✓ Service history tracking 
✓ Reminders & updates 
✓ Connect with mechanics 
✓ Exclusive member offers 

Use my garage code: *${grage_referal_code}* Sign up here: ${referralUrl}
Let's grow together! 🚀 

Best regards,
${grage_name || "Our Garage"}`;

  const menuItems = [
    {
      icon: "fas fa-user-plus",
      title: "Add New Customer",
      description: "Add customer to your garage",
      link: "/add-customer-vehicle",
      color: "#667eea",
    },
    {
      icon: "fas fa-users",
      title: "Customer List",
      description: "View all your customers",
      link: "/customers",
      color: "#fc8181",
    },
    {
      icon: "fas fa-car",
      title: "Vehicle List",
      description: "Manage customer vehicles",
      link: "/vehicles",
      color: "#68d391",
    },
    {
      icon: "fas fa-user-cog",
      title: "Profile",
      description: "Update your information",
      link: "/profile",
      color: "#f6ad55",
    },
    {
      icon: "fas fa-history",
      title: "History",
      description: "View service history",
      link: "/history",
      color: "#4fd1c5",
    },
    {
      icon: "fas fa-phone rotate90",
      title: "Reminder",
      description: "Reminder for your customers",
      link: "/serviceReminderList",
      color: "#48bb78",
    },

    {
      icon: "fas fa-file",
      title: "Insurance List",
      description: "View Insurance history",
      link: "/insurance",
      color: "#4299e1",
    },
    {
      icon: "fas fa-store",
      title: "Vendors",
      description: "Manage your spare part suppliers",
      link: "/vendors",
      color: "#38b2ac",
    },
    {
      icon: "fas fa-shopping-cart",
      title: "Purchases",
      description: "Manage purchase entries & bills",
      link: "/purchases",
      color: "#e53e3e",
    },
    {
      icon: "fas fa-exchange-alt",
      title: "Transaction",
      description: "Manage other transaction",
      link: "/transaction",
      color: "#9f7aea",
    },
    {
      icon: "fas fa-tachometer-alt",
      title: "Dashboard",
      description: "Manage your garage",
      link: "/transaction-dashboard",
      color: "#91d55aff",
    },
    {
      icon: "fas fa-lightbulb",
      title: "Suggestions",
      description: "Share your feedback and ideas",
      link: "/suggestions",
      color: "#ed8936",
    },
    {
      icon: "fab fa-whatsapp",
      title: "Invite on WhatsApp",
      description: "Share with friends & family",
      link: "#",
      color: "#25D366",
      action: () => {
        const encodedMessage = encodeURIComponent(whatsappMessage);
        window.open(`https://wa.me/?text=${encodedMessage}`, "_blank");
      },
    },
  ];
  const handleLogout = () => {
    localStorage.removeItem("userData");
    navigate("/logoutApp/" + grage_id);
  };

  const socialLinks = [
    {
      icon: "fab fa-facebook",
      link: "https://www.facebook.com/MydigiGarageApp",
      color: "#1877F2",
      name: "Facebook",
    },
    {
      icon: "fab fa-instagram",
      link: "https://www.instagram.com/mydigigarageapp/",
      color: "#E4405F",
      name: "Instagram",
    },
  ];

  // Membership status badge
  const getMembershipBadge = () => {
    if (!membership_status) {
      return {
        text: "No Membership",
        color: "#718096",
        bgColor: "#e2e8f0",
      };
    }

    switch (membership_status.toLowerCase()) {
      case "active":
        return {
          text: "Active Member",
          color: "#276749",
          bgColor: "#c6f6d5",
        };
      case "pending":
        return {
          text: "Pending",
          color: "#975a16",
          bgColor: "#feebc8",
        };
      case "expired":
        return {
          text: "Expired",
          color: "#c53030",
          bgColor: "#fed7d7",
        };
      default:
        return {
          text: membership_status,
          color: "#4a5568",
          bgColor: "#e2e8f0",
        };
    }
  };

  const membershipBadge = getMembershipBadge();

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f8fafc",
        paddingBottom: "5px",
      }}
    >
      {/* Header Section */}
      <div
        style={{
          background:
            "linear-gradient(135deg, rgb(3 82 161) 0%, rgb(3 82 161) 100%)",
          color: "white",
          padding: "20px",
          borderRadius: "0 0 20px 20px",
          marginBottom: "20px",
          boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Decorative elements */}
        <div
          style={{
            position: "absolute",
            top: "-50px",
            right: "-50px",
            width: "150px",
            height: "150px",
            background: "rgba(255,255,255,0.1)",
            borderRadius: "50%",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            bottom: "-30px",
            left: "-30px",
            width: "100px",
            height: "100px",
            background: "rgba(255,255,255,0.05)",
            borderRadius: "50%",
          }}
        ></div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            maxWidth: "1200px",
            margin: "0 auto",
            position: "relative",
            zIndex: 1,
          }}
        >
          <div
            style={{
              display: "-webkit-inline-box",
              alignItems: "center",
              gap: "15px",
            }}
            className="moreprofile"
          >
            <div
              style={{
                width: "60px",
                height: "60px",
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "24px",
                backdropFilter: "blur(10px)",
              }}
            >
              <i className="fas fa-user"></i>
            </div>
            <div style={{ textAlign: "left", width: "70%" }}>
              <h2
                style={{
                  margin: 0,
                  fontSize: "1.4rem",
                  fontWeight: "600",
                }}
              >
                {grage_name || "Garage Owner"}
              </h2>
              <p
                style={{
                  margin: "5px 0 0 0",
                  opacity: 0.9,
                  fontSize: "0.9rem",
                }}
              >
                {garageLoginNumber || ""}
              </p>

              {/* Membership Status Badge */}
            </div>
          </div>
          <Link
            to="/profile"
            style={{
              background: "rgba(255, 255, 255, 0.2)",
              border: "none",
              color: "white",
              padding: "10px 15px",
              borderRadius: "25px",
              cursor: "pointer",
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "0.9rem",
              backdropFilter: "blur(10px)",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "rgba(255, 255, 255, 0.3)";
              e.target.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "rgba(255, 255, 255, 0.2)";
              e.target.style.transform = "translateY(0)";
            }}
          >
            <i className="fas fa-edit"></i>
            Edit
          </Link>
        </div>
      </div>

      {/* Quick Stats Banner */}
      {membership_hide_show == 1 ? (
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto 20px",
            padding: "0 20px",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
              gap: "15px",
              marginBottom: "20px",
            }}
          >
            <Link to="/PackageList" style={{ textDecoration: "none" }}>
              <div
                style={{
                  background:
                    "linear-gradient(135deg, #805ad5 0%, #9f7aea 100%)",
                  color: "white",
                  padding: "15px",
                  borderRadius: "12px",
                  textAlign: "center",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 15px rgba(128, 90, 213, 0.3)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 25px rgba(128, 90, 213, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 15px rgba(128, 90, 213, 0.3)";
                }}
              >
                <i
                  className="fas fa-box"
                  style={{ fontSize: "24px", marginBottom: "8px" }}
                ></i>
                <div style={{ fontWeight: "600", fontSize: "0.9rem" }}>
                  Packages
                </div>
                <div style={{ fontSize: "0.8rem", opacity: 0.9 }}>
                  View Plans
                </div>
              </div>
            </Link>

            <Link to="/membership" style={{ textDecoration: "none" }}>
              <div
                style={{
                  background:
                    "linear-gradient(135deg, #d69e2e 0%, #ed8936 100%)",
                  color: "white",
                  padding: "15px",
                  borderRadius: "12px",
                  textAlign: "center",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 15px rgba(214, 158, 46, 0.3)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 25px rgba(214, 158, 46, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 15px rgba(214, 158, 46, 0.3)";
                }}
              >
                <i
                  className="fas fa-crown"
                  style={{ fontSize: "24px", marginBottom: "8px" }}
                ></i>
                <div style={{ fontWeight: "600", fontSize: "0.9rem" }}>
                  Membership
                </div>
                <div style={{ fontSize: "0.8rem", opacity: 0.9 }}>My Plan</div>
              </div>
            </Link>
          </div>
        </div>
      ) : (
        ""
      )}

      {/* Menu Grid */}
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "0 20px",
        }}
      >
        <h3
          style={{
            color: "#2d3748",
            fontSize: "1.2rem",
            marginBottom: "15px",
            paddingLeft: "5px",
            fontWeight: "600",
          }}
        >
          Quick Access
        </h3>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "20px",
            marginTop: "10px",
            textAlign: "left",
          }}
        >
          {menuItems.map((item, index) => (
            <div
              key={index}
              onClick={item.action || (() => {})}
              style={{
                background: "white",
                borderRadius: "15px",
                padding: "20px",
                textDecoration: "none",
                color: "inherit",
                boxShadow: "0 2px 10px rgba(0, 0, 0, 0.08)",
                border: "1px solid #f0f0f0",
                transition: "all 0.3s ease",
                display: "block",
                position: "relative",
                overflow: "hidden",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 8px 25px rgba(0, 0, 0, 0.15)";
                if (item.color === "#25D366") {
                  e.currentTarget.style.boxShadow =
                    "0 8px 25px rgba(37, 211, 102, 0.2)";
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 2px 10px rgba(0, 0, 0, 0.08)";
              }}
            >
              {item.link !== "#" ? (
                <Link
                  to={item.link}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "15px",
                  }}
                >
                  <MenuContent item={item} />
                </Link>
              ) : (
                <MenuContent item={item} />
              )}
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: "4px",
                  background: item.color,
                  opacity: 0.8,
                }}
              ></div>
            </div>
          ))}
        </div>

        {/* Social Media Section */}
        <div
          style={{
            marginTop: "15px",
            padding: "15px",
            borderRadius: "15px",
            textAlign: "center",
            background: "white",
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
          }}
        >
          <h3
            style={{
              marginBottom: "15px",
              color: "#2d3748",
              fontSize: "1.2rem",
              fontWeight: "600",
            }}
          >
            Follow us on
          </h3>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "20px",
              flexWrap: "wrap",
            }}
          >
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "18px",
                  color: "white",
                  background: social.color,
                  textDecoration: "none",
                  transition: "all 0.3s ease",
                  boxShadow: `0 4px 10px ${social.color}40`,
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "translateY(-5px)";
                  e.target.style.boxShadow = `0 8px 20px ${social.color}60`;
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = `0 4px 10px ${social.color}40`;
                }}
                title={social.name}
              >
                <i className={social.icon}></i>
              </a>
            ))}
          </div>

          <div
            style={{
              marginTop: "20px",
              paddingTop: "20px",
              borderTop: "1px solid #e2e8f0",
              color: "#718096",
              fontSize: "0.9rem",
            }}
          >
            <Link
              to="/terms"
              style={{
                color: "#4299e1",
                textDecoration: "none",
                margin: "0 5px",
                fontWeight: "500",
              }}
            >
              Terms & Conditions
            </Link>
            |
            <Link
              to="/privacy"
              style={{
                color: "#4299e1",
                textDecoration: "none",
                margin: "0 5px",
                fontWeight: "500",
              }}
            >
              Privacy Policy
            </Link>
            |
            <Link
              to="/about-us"
              style={{
                color: "#4299e1",
                textDecoration: "none",
                margin: "0 5px",
                fontWeight: "500",
              }}
            >
              About Us
            </Link>
            <div style={{ marginTop: "15px" }}>
              <button
                onClick={() => setShowLogoutConfirm(true)}
                style={{
                  background:
                    "linear-gradient(135deg, #fc8181 0%, #f56565 100%)",
                  color: "white",
                  border: "none",
                  padding: "10px 25px",
                  borderRadius: "25px",
                  cursor: "pointer",
                  fontSize: "0.95rem",
                  fontWeight: "600",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 15px rgba(245, 101, 101, 0.3)",
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow =
                    "0 6px 20px rgba(245, 101, 101, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow =
                    "0 4px 15px rgba(245, 101, 101, 0.3)";
                }}
              >
                <i
                  className="fas fa-sign-out-alt"
                  style={{ marginRight: "8px" }}
                ></i>
                Logout
              </button>
            </div>
          </div>
        </div>

        {/* Logout Confirmation Modal */}
        {showLogoutConfirm && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1001,
              backdropFilter: "blur(5px)",
            }}
            onClick={() => setShowLogoutConfirm(false)}
          >
            <div
              style={{
                background: "white",
                borderRadius: "15px",
                padding: "30px",
                maxWidth: "400px",
                width: "90%",
                textAlign: "center",
                boxShadow: "0 10px 40px rgba(0, 0, 0, 0.2)",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  background: "#fed7d7",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "24px",
                  color: "#f56565",
                  margin: "0 auto 20px",
                }}
              >
                <i className="fas fa-sign-out-alt"></i>
              </div>
              <h3
                style={{
                  margin: "0 0 10px 0",
                  color: "#2d3748",
                  fontSize: "1.3rem",
                }}
              >
                Leave {grage_name || "the Garage"} Family?
              </h3>
              <p style={{ color: "#718096", marginBottom: "25px" }}>
                You will be logged out of your account.
              </p>
              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "center",
                }}
              >
                <button
                  onClick={() => setShowLogoutConfirm(false)}
                  style={{
                    background: "#e2e8f0",
                    color: "#4a5568",
                    border: "none",
                    padding: "12px 25px",
                    borderRadius: "25px",
                    cursor: "pointer",
                    fontSize: "0.95rem",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                    flex: 1,
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#cbd5e0";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "#e2e8f0";
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleLogout}
                  style={{
                    background:
                      "linear-gradient(135deg, #f56565 0%, #fc8181 100%)",
                    color: "white",
                    border: "none",
                    padding: "12px 25px",
                    borderRadius: "25px",
                    cursor: "pointer",
                    fontSize: "0.95rem",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                    flex: 1,
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow =
                      "0 6px 20px rgba(245, 101, 101, 0.4)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "none";
                  }}
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
      <div
        style={{
          marginTop: "15px",
          textAlign: "center",
          padding: "20px",
          color: "#a0aec0",
          fontSize: "0.8rem",
          borderTop: "1px solid #f0f0f0",
          background: "white",
        }}
      >
        <p style={{ margin: 0 }}>MydigiGarage Management System v1.0</p>
        <p style={{ margin: "5px 0 0 0" }}>
          © 2024 All rights reserved by Bits Infotech
        </p>
      </div>
      <style jsx>{`
        .rotate90 {
          transform: rotateZ(90deg);
        }
      `}</style>
    </div>
  );
};

// Helper component for menu content
const MenuContent = ({ item }) => (
  <div
    style={{
      display: "flex",
      alignItems: "flex-start",
      gap: "15px",
      width: "100%",
    }}
  >
    <div
      style={{
        width: "50px",
        height: "50px",
        background: `${item.color}15`,
        borderRadius: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "20px",
        color: item.color,
        flexShrink: 0,
      }}
    >
      <i className={item.icon}></i>
    </div>
    <div style={{ flex: 1 }}>
      <h3
        style={{
          margin: "0 0 5px 0",
          fontSize: "1.1rem",
          fontWeight: "600",
          color: "#2d3748",
        }}
      >
        {item.title}
      </h3>
      <p
        style={{
          margin: 0,
          fontSize: "0.85rem",
          color: "#718096",
          lineHeight: "1.4",
        }}
      >
        {item.description}
      </p>
    </div>
    <div
      style={{
        color: "#cbd5e0",
        fontSize: "14px",
        alignSelf: "center",
        transition: "all 0.3s ease",
      }}
    >
      <i className="fas fa-chevron-right"></i>
    </div>
  </div>
);

export default More;
